import React from 'react'
import { logger } from '../../logging'

import { Text, View, Flex, Loader } from '@aws-amplify/ui-react'


import * as models from '@mytmpvpn/mytmpvpn-common/models/vpn'
import { convertSecondsToHMSShort } from '../Common'
import { useComponentSize } from '../ResponsiveSize'

export function Metrics({ metrics }: { metrics: models.VpnMetrics | undefined }) {
  logger.log(`Metrics: ${JSON.stringify(metrics)}`)
  const componentSize = useComponentSize()

  if (!metrics) return <Loader />

  if (componentSize === 'short') {
    return (
      <Text fontSize={'0.7rem'}>
        {metrics.peanuts !== null ? `${metrics.peanuts.toFixed(2)}🥜` : ''} {metrics.duration !== null ? convertSecondsToHMSShort(metrics.duration) : ''}
      </Text>
    )
  }

  return (
    <View fontSize={'0.75rem'}>
      <Flex alignItems={'center'}>
        🥜 <Text>{metrics.peanuts === null ? 'N/A' : `${metrics.peanuts.toFixed(2)} peanuts`}</Text>
      </Flex>
      <Flex alignItems={'center'}>
        ⏳ <Text>{metrics.duration === null ? 'N/A' : convertSecondsToHMSShort(metrics.duration)}</Text>
      </Flex>

      <Flex alignItems={'center'}>
        ↔️ <Text>{metrics.bytes === null ? 'N/A' : `${(metrics.bytes / 1024 / 1024).toFixed(2)} MiB`}</Text >
      </Flex>
    </View>
  )
}
